// in src/posts.js
import React from 'react';
import {BooleanField, ImageField, ImageInput, DeleteButton, BooleanInput, ShowButton, DateField, RichTextField, Show, SimpleShowLayout, SimpleList, Filter, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import Dropzone from 'react-dropzone'
import { useMediaQuery } from '@mui/material';
import { RichTextInput } from 'ra-input-rich-text';
//Utils
import Validators from './renderFields/validatorsFields';

const QuestionFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="name" alwaysOn />
    </Filter>
);

export const QuestionList = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Listar Preguntas" filters={<QuestionFilter />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.name}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="name" label="Pregunta" />
                    <ReferenceField label="Servicio ID" source="serviceQualifyId" reference="services-qualifies">
                        <TextField source="name" />
                    </ReferenceField>
                    <BooleanField source="state" label="Estado" />
                    <EditButton />
                    <ShowButton />
                    <DeleteButton />
                </Datagrid>
            )}
        </List>
    );
};
const QuestionName = ({ record }) => {
    return <span>Pregunta {record ? `"${record.name}"` : ''}</span>;
};

const validateFields = (values) => {
    const errors = {};
    
    if (!values.name) {
      errors.name = 'La Pregunta es obligatorio';
    }
   
    if (!values.serviceQualifyId) {
      errors.serviceQualifyId = 'Service Qualify es obligatorio';
    }
 
    return errors;
};

export const QuestionEdit = (props) => (
    <Edit title={<QuestionName />} {...props}>
        <SimpleForm validate={validateFields}>
            <TextInput source="id" disabled />
            <TextInput source="name" label="Pregunta" />
            <ReferenceInput label="Servicio ID" source="serviceQualifyId" reference="services-qualifies" allowEmpty>
                <SelectInput optionText="name" source="serviceQualifyId" />
            </ReferenceInput>
            <BooleanInput label="Estado" source="state" />
        </SimpleForm>
    </Edit>
);

export const QuestionCreate = (props) => (
    <Create {...props}>
        <SimpleForm validate={validateFields}>
            <TextInput source="name" label="Pregunta" />
            <ReferenceInput label="Servicio ID" source="serviceQualifyId" reference="services-qualifies" allowEmpty>
                <SelectInput optionText="name" source="serviceQualifyId" />
            </ReferenceInput>
            <BooleanInput label="Estado" source="state" defaultValue={true} />
        </SimpleForm>
    </Create>
);

export const QuestionShow = (props) => (
    <Show title={<QuestionName />} {...props}>
        <SimpleShowLayout>
            <TextField source="name" label="Pregunta"/>
            <ReferenceField label="Servicio ID" source="serviceQualifyId" reference="services-qualifies">
                <TextField source="name" />
            </ReferenceField>
            <BooleanField  label="Estado" source="state" />
            <DateField label="Ultima actualización" source="updatedAt" />
            <DateField label="Fecha de creación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);
